module.exports = __webpack_public_path__ + "media/images/home/white-arrow-cb610ae189b84fdd8b7f5a2f2150ee57.png";